import AInputText from './a-input-text.vue';

export default AInputText;
